import { render } from "./TrendingChart.vue?vue&type=template&id=7353f377&scoped=true"
import script from "./TrendingChart.vue?vue&type=script&lang=js"
export * from "./TrendingChart.vue?vue&type=script&lang=js"

import "./TrendingChart.vue?vue&type=style&index=0&id=7353f377&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7353f377"]])

export default __exports__